import { render } from "./Unauthorized.vue?vue&type=template&id=52174afd&scoped=true"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"

import "./Unauthorized.vue?vue&type=style&index=0&id=52174afd&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52174afd"]])

export default __exports__